import { Injectable } from '@angular/core';
import * as legend from '../config/legend';
import * as grids from '../config/grid';
import { ECharts } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  //根据窗口大小设置图例的大小
  setEchartLegendSizeByWindows() {
    let width = document.body.clientWidth;
    let legendSize = [25, 14, 10]; //init
    /* 
      说明legendSize是一个长度为3的数组，其中index分别代表
      index=0  itemWidth  //图例标记的图形宽度。
      index=1  itemHeight  //图例标记的图形高度。
      index=2  itemGap  //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。
    */

    if (width <= 768) {
      legendSize = [4, 6, 6];
    } else if (width > 768 && width <= 992) {
      legendSize = [7, 7, 7];
    } else if (width > 992 && width <= 1200) {
      legendSize = [10, 10, 10];
    } else if (width > 1200 && width <= 1920) {
      legendSize = [12, 12, 10];
    } else if (width > 1920) {
      legendSize = [14, 14, 14];
    }
    return legendSize;
  }

  // 根据窗口大小设置visualmap(连续型 纵向)大小
  setEchartVisualmapVerticalSizeByWindows(): number[] {
    let width = document.body.clientWidth;
    let visualmapSize = [20, 140];
    /* 
      visualmapSize[0] : itemWidth
      visualmapSize[1] : itemHeight
    */
    if (width <= 768) {
      visualmapSize = [10, 70];
    } else if (width > 768 && width <= 992) {
      visualmapSize = [10, 70];
    } else if (width > 992 && width <= 1200) {
      visualmapSize = [20, 90];
    } else if (width > 1200 && width < 1920) {
      visualmapSize = [20, 100];
    } else if (width >= 1920) {
      visualmapSize = [20, 140];
    }
    return visualmapSize;
  }
  // 根据窗口大小判断显示 radio 或者 select
  changeType(): string {
    let width = document.body.clientWidth;
    let radioOrSelect = "0";

    if (width <= 768) {
      radioOrSelect = "0";
    } else if (width > 768 && width <= 992) {
      radioOrSelect = "0";
    } else if (width > 992 && width <= 1200) {
      radioOrSelect = "1";
    } else if (width > 1200 && width <= 1920) {
      radioOrSelect = "1";
    } else if (width > 2000) {
      radioOrSelect = "1";
    }
    return radioOrSelect;
  }

  // 根据窗口大小调整legend位置(简报用)
  changeLegendPosition() {
    let width = document.body.clientWidth;
    if (width <= 1748) {
      return "v";
    } else return "h";
  }
  // 根据窗口大小判断显示 字体大小、图的边距、工具栏图标大小
  changeFontSize() {
    let width = document.body.clientWidth;
    let echartsStyle = {
      fontSize: 12,
      yAxisLabelFontSize: 11,
      toolboxSize: 14,
      markLineSymbolSize: 8,
      // bottom legend grid
      interval: {
        left: grids.baseDefaultPadding,
        right: grids.baseDefaultPadding,
        bottom: legend.bottomLegendHeight,
        top: grids.baseDefaultTopPadding,
        containLabel: true,
      },
      horizontalInterval: {
        left: grids.horizontalLeftPadding,
        right: grids.horizontalRightPadding,
        bottom: legend.bottomLegendHeight,
        top: grids.baseDefaultTopPadding,
        containLabel: true,
      },
      horizontalSamllInterval: {
        left: grids.horizontalSmallLeftPadding,
        right: grids.horizontalSmallRightPadding,
        bottom: legend.bottomLegendHeight,
        top: grids.baseDefaultTopPadding,
        containLabel: true,
      },
      // 底部图例 小内边距
      smallInterval: {
        left: grids.baseSmallPadding,
        right: grids.baseSmallPadding,
        bottom: legend.bottomLegendHeight,
        top: grids.baseSmallPadding,
        containLabel: true,
      },
      pyramidGrid: {
        left: grids.baseDefaultPadding,
        right: grids.baseDefaultPadding,
        bottom: 50,
        top: grids.baseDefaultPadding,
        containLabel: true,
      },
      smallPyramidGrid: {
        left: grids.baseSmallPadding,
        right: grids.baseSmallPadding,
        bottom: 50,
        top: grids.baseSmallPadding,
        containLabel: true
      },
      rightLegendGrid: {
        left: grids.baseDefaultPadding,
        right: legend.rightLegendWidth,
        bottom: grids.baseDefaultBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      smallRightLegendGrid: {
        left: grids.baseSmallPadding,
        right: legend.rightLegendWidth,
        bottom: grids.baseSmallPadding,
        top: grids.baseSmallPadding,
        containLabel: true
      },
      topLegendGrid: {
        left: grids.baseDefaultPadding,
        right: grids.baseDefaultPadding,
        bottom: grids.baseDefaultBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      horizontalTopLegendGrid: {
        left: grids.horizontalLeftPadding,
        right: grids.horizontalRightPadding,
        bottom: grids.horizontalBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      horizontalSmallTopLegendGrid: {
        left: grids.horizontalSmallLeftPadding,
        right: grids.horizontalSmallRightPadding,
        bottom: grids.horizontalBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      smallTopLegendGrid: {
        left: grids.baseSmallPadding,
        right: grids.baseSmallPadding,
        bottom: grids.baseSmallPadding,
        top: grids.baseSmallPadding,
        containLabel: true
      },
      noLegendGrid: {
        left: grids.baseDefaultPadding,
        right: grids.baseDefaultPadding,
        bottom: grids.baseDefaultBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      horizontalNoLegendGrid: {
        left: grids.horizontalLeftPadding,
        right: grids.horizontalRightPadding,
        bottom: grids.horizontalBottomPadding,
        top: grids.baseDefaultTopPadding,
        containLabel: true
      },
      smallNoLegendGrid: {
        left: grids.baseSmallPadding,
        right: grids.baseSmallPadding,
        bottom: grids.baseSmallBottomPadding,
        top: grids.baseSmallPadding,
        containLabel: true
      },
      horizontalSmallNoLegendGrid: {
        left: grids.horizontalSmallLeftPadding,
        right: grids.horizontalSmallRightPadding,
        bottom: grids.horizontalSmallBottomPadding,
        top: grids.baseSmallPadding,
        containLabel: true
      },
      withoutLegendGrid: {
        left: 10,
        right: 10,
        bottom: 5,
        top: 10,
        containLabel: true
      }
    };

    if (width <= 768) {
      echartsStyle.yAxisLabelFontSize = 5
      echartsStyle.fontSize = 6;
      echartsStyle.toolboxSize = 10;
      echartsStyle.markLineSymbolSize = 6
    } else if (width > 768 && width <= 992) {
      echartsStyle.yAxisLabelFontSize = 7;
      echartsStyle.fontSize = 8;
      echartsStyle.toolboxSize = 11;
      echartsStyle.markLineSymbolSize = 6
    } else if (width > 992 && width <= 1200) {
      echartsStyle.yAxisLabelFontSize = 9;
      echartsStyle.fontSize = 10;
      echartsStyle.toolboxSize = 12;
      echartsStyle.markLineSymbolSize = 8;
    } else if (width > 1200 && width <= 1920) {
      echartsStyle.yAxisLabelFontSize = 11;
      echartsStyle.fontSize = 12;
      echartsStyle.toolboxSize = 14;
      echartsStyle.markLineSymbolSize = 8;
    } else if (width > 1920) {
      echartsStyle.yAxisLabelFontSize = 11;
      echartsStyle.fontSize = 12;
      echartsStyle.toolboxSize = 14;
      echartsStyle.markLineSymbolSize = 10;
    }
    return echartsStyle;
  }

  getWindowLevel() {
    let width = document.body.clientWidth;
    if (width <= 768) {
      return "small";
    } else if (width > 768 && width <= 992) {
      return "middle";
    } else if (width > 992 && width <= 1200) {
      return "large";
    } else if (width > 1200 && width <= 1920) {
      return "superLarge";
    } else {
      return "default";
    }
  }

  //根据窗口大小设置legend图例和toolbox的大小
  setLegendAndToolboxByWindows() {
    let width = document.body.clientWidth;
    let resSize = {
      legendSize: 10,//init
      legendfontSize: 12, //init
      toolboxSize: 12, //init
      tooltipSize: 12, //init
    }

    if (width <= 768) {
      resSize.legendSize = 6;
      resSize.toolboxSize = 6;
      resSize.legendfontSize = 6
      resSize.tooltipSize = 6
    } else if (width > 768 && width <= 992) {
      resSize.legendSize = 7;
      resSize.toolboxSize = 7;
      resSize.legendfontSize = 7
      resSize.tooltipSize = 7
    } else if (width > 992 && width <= 1200) {
      resSize.legendSize = 8;
      resSize.toolboxSize = 10;
      resSize.legendfontSize = 10
      resSize.tooltipSize = 10
    } else if (width > 1200 && width <= 1920) {
      resSize.legendSize = 10;
      resSize.toolboxSize = 12;
      resSize.legendfontSize = 12
      resSize.tooltipSize = 12
    } else if (width > 1920) {
      resSize.legendSize = 12;
      resSize.toolboxSize = 14;
      resSize.legendfontSize = 14
      resSize.tooltipSize = 14
    }
    return resSize;
  }

  //todo 根据窗口大小设置声学分析折线图toolbox  grid
  setNoiseAnalysisLineByWindows() {
    const width = document.body.clientWidth;
    let resSize = {
      toolbox: {
        itemGap: 10,
        right: 30, // 右边距 
        itemSize: 12, //工具栏 icon 的大小
      },
      grid: [{
        left: 50,
        right: 40,
      },
      {
        left: 50,
        right: 40,
      }],
      legend: [{
        itemGap: 10,
        left: 50,
      },
      {
        itemGap: 10,
        left: 50,
      }]
    }

    if (width <= 768) {
      resSize.toolbox = {
        itemGap: 6,
        right: 10, // 右边距 
        itemSize: 6, //工具栏 icon 的大小
      }
      resSize.grid = [{
        left: 30,
        right: 16,
      },
      {
        left: 30,
        right: 16,
      }]
      resSize.legend = [{
        itemGap: 6,
        left: 30,
      },
      {
        itemGap: 6,
        left: 30,
      }]
    } else if (width > 768 && width <= 992) {
      resSize.toolbox = {
        itemGap: 7,
        right: 10, // 右边距 
        itemSize: 7, //工具栏 icon 的大小
      }
      resSize.grid = [{
        left: 30,
        right: 17,
      },
      {
        left: 30,
        right: 17,
      }]
      resSize.legend = [{
        itemGap: 7,
        left: 30,
      },
      {
        itemGap: 7,
        left: 30,
      }]
    } else if (width > 992 && width <= 1200) {
      resSize.toolbox = {
        itemGap: 8,
        right: 20, // 右边距 
        itemSize: 10, //工具栏 icon 的大小
      }
      resSize.grid = [{
        left: 40,
        right: 28,
      },
      {
        left: 40,
        right: 28,
      }]
      resSize.legend = [{
        itemGap: 8,
        left: 40,
      },
      {
        itemGap: 8,
        left: 40,
      }]
    } else if (width > 1200 && width <= 1920) {
      resSize.toolbox = {
        itemGap: 8,
        right: 22, // 右边距 
        itemSize: 12, //工具栏 icon 的大小
      }
      resSize.grid = [{
        left: 50,
        right: 30,
      },
      {
        left: 50,
        right: 30,
      }]
      resSize.legend = [{
        itemGap: 8,
        left: 50,
      },
      {
        itemGap: 8,
        left: 50,
      }]
    } else if (width > 1920) {
      resSize.toolbox = {
        itemGap: 10,
        right: 30, // 右边距 
        itemSize: 14, //工具栏 icon 的大小
      }
      resSize.grid = [{
        left: 60,
        right: 40,
      },
      {
        left: 60,
        right: 40,
      }]
      resSize.legend = [{
        itemGap: 10,
        left: 60,
      },
      {
        itemGap: 10,
        left: 60,
      }]
    }
    return resSize;
  }

  //todo 设置声学分析折线图toolbox  grid
  setNoiseDropboxLine() {
    const width = document.body.clientWidth;
    let echartsStyle = {
      legend: {
        itemSize: 12,
        itemGap: 10
      },
      toolbox: {
        itemGap: 10,
        right: 20, // 右边距 
        top: 0, // 右边距 
        itemSize: 14, //工具栏 icon 的大小
      },
      grid: {
        left: 45,
        top: 35,
        right: 30,
        bottom: 30,
        containLabel: true
      },
    };
    if (width <= 768) {
      echartsStyle.legend.itemGap = 6
      echartsStyle.legend.itemSize = 6
      echartsStyle.toolbox.itemGap = 6
      echartsStyle.toolbox.itemSize = 6
    } else if (width > 768 && width <= 992) {
      echartsStyle.legend.itemGap = 7
      echartsStyle.legend.itemSize = 7
      echartsStyle.toolbox.itemGap = 7
      echartsStyle.toolbox.itemSize = 7

    } else if (width > 992 && width <= 1200) {
      echartsStyle.legend.itemGap = 8
      echartsStyle.legend.itemSize = 10
      echartsStyle.toolbox.itemGap = 8
      echartsStyle.toolbox.itemSize = 10

    } else if (width > 1200 && width <= 1920) {
      echartsStyle.legend.itemGap = 10
      echartsStyle.legend.itemSize = 12
      echartsStyle.toolbox.itemGap = 10
      echartsStyle.toolbox.itemSize = 14
    } else if (width > 1920) {
      echartsStyle.legend.itemGap = 12
      echartsStyle.legend.itemSize = 14
      echartsStyle.toolbox.itemGap = 12
      echartsStyle.toolbox.itemSize = 14
    }
    return echartsStyle;
  }
  // 设置饼图resize
  setPieChartResize(chartInstance: ECharts, style) {
    chartInstance.setOption({
      legend: {
        itemHeight: style.fontSize - 2,
        itemWidth: style.fontSize - 2,
        textStyle: {
          fontSize: style.fontSize - 1
        },
        pageIconSize: style.fontSize,
        pageTextStyle: {
          fontSize: style.fontSize - 1
        }
      },
      toolbox: {
        itemSize: style.toolboxSize,
      },
      series: [{
        label: {
          fontSize: style.fontSize - 1
        }
      }]
    })
  }
  // 设置地图的resize
  setMapChartResize(chartInstance: ECharts, style) {

    chartInstance.setOption({
      visualMap: [{
        textStyle: {
          fontSize: style.fontSize - 2
        }
      }],
      series: [{
        label: {
          textStyle: {
            fontSize: style.fontSize - 2
          }
        }
      }]
    })
  }

  // 根据模式和图例位置 返回grid位置
  getChartGrid(smallMode: boolean, legendPosition) {

    let style = this.changeFontSize();
    let grid = style.interval;
    if (smallMode) {
      switch (legendPosition) {
        case 'bottom':
          grid = style.smallInterval;
          break;
        case 'top':
          grid = style.smallTopLegendGrid;
          break;
        case 'right':
          grid = style.smallRightLegendGrid;
          break;
        case 'none':
          grid = style.smallNoLegendGrid;
          break;
        default:
          grid = style.smallInterval;
          break;
      }
    } else {
      switch (legendPosition) {
        case 'bottom':
          grid = style.interval;
          break;
        case 'top':
          grid = style.topLegendGrid;
          break;
        case 'right':
          grid = style.rightLegendGrid;
          break;
        case 'none':
          grid = style.noLegendGrid;
          break;
        default:
          grid = style.interval;
          break;
      }
    }
    return grid;
  }


  changeChartColors(chartOption, chartColors) {
    chartOption.color = chartColors
  }
}
